import Vue from 'vue'
import Vuex from 'vuex'

import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'

import { createTravelStore } from './modules/travel'

Vue.use(Vuex)

var debug = process.env.NODE_ENV !== 'production'

var options = {
  key: 'TravelShop-Travel',
  storage: window.sessionStorage
}

const plugins = [createPersistedState(options)]

if (debug) {
  plugins.push(createLogger())
}

var modules = {
  travel: createTravelStore(options)
}

export default new Vuex.Store({
  strict: debug,
  modules: modules,
  plugins: plugins
})



// WEBPACK FOOTER //
// ./src/configs/store/index.js